module.exports = __webpack_public_path__ + "img/ИФ-1(А)-001.29afbd81.png";